export default __webpack_public_path__ + "static/media/man.2c8196db.jpg";